import { connect } from 'react-redux';
import { toggleFeaturesModal } from 'project/ducks/features';
import { getProject } from 'project/ducks/project';
import Upgrade from 'focus_groups/components/upgrade';

const mapStateToProps = (state) => {
  return {
    project: getProject(state)
  };
}

export default connect(mapStateToProps, { toggleFeaturesModal })(Upgrade);



// WEBPACK FOOTER //
// ./focus_groups/containers/upgrade.js